import LmsRoutes from './lms'
import EmsRoutes from './ems'
import SettingsRoutes from './settings'
import { RouteRecordRaw } from 'vue-router'

export default <RouteRecordRaw[]>[...LmsRoutes, ...EmsRoutes, ...SettingsRoutes]
